module.exports = __webpack_public_path__ + "img/foglio_di_calcolo.1cba4680.svg";